window.addEventListener('load', function () {
  sendConsentToGTM();
  document.addEventListener("visitorConsentCollected", () => sendConsentToGTM());
  const ctaButtons = document.querySelectorAll('.button');
  ctaButtons.forEach(button => {
    button.addEventListener("click", () => registerCTAEvent(button));
  });
  trackCalendlyEvent();
});
function sendConsentToGTM() {
  const consent = window.Shopify.customerPrivacy.currentVisitorConsent();
  if (consent) {
    gtag('consent', 'update', {
      ad_storage: consent.marketing === "yes" ? "granted" : "denied",
      ad_user_data: consent.marketing === "yes" ? "granted" : "denied",
      ad_personalization: consent.marketing === "yes" ? "granted" : "denied",
      analytics_storage: consent.analytics === "yes" ? "granted" : "denied",
      personalization_storage: consent.preferences === "yes" ? "granted" : "denied"
    });
    dataLayer.push({
      event: "Consent Updated",
      consent: consent
    });
  }
}
function registerCTAEvent(button) {
  dataLayer.push({
    event: "Cta Clicked",
    label: button.innerText,
    anchor: button.getAttribute('href'),
    url: window.location.href
  });
}
function trackCalendlyEvent() {
  window.addEventListener('message', function (e) {
    if (e.data.event && e.data.event.indexOf('calendly') === 0) {
      console.log("calendly event : ", e.data.event);
      dataLayer.push({
        event: "Calendly Event",
        calendlyEvent: e.data.event
      });
    }
  });
}